export default {"src":"/_next/static/media/twitch.4e160d0a.svg","height":22,"width":22};